import { ITALIAN_REGIONS, type RegionCode } from './territorial-rules';

export const TERRITORIAL_AREAS = [
  { id: 'nord-est', name: 'Nord - Est' },
  { id: 'centro', name: 'Centro' },
  { id: 'nord-ovest', name: 'Nord - Ovest' },
  { id: 'sud', name: 'Sud' },
] as const;

export type TerritorialAreaId = typeof TERRITORIAL_AREAS[number]['id'];
export type RegionAssignments = Record<RegionCode, TerritorialAreaId | null>;

const territorialAreaIds = new Set<string>(TERRITORIAL_AREAS.map(({ id }) => id));

export const DEFAULT_REGION_ASSIGNMENTS: RegionAssignments = {
  ABR: 'centro',
  BAS: 'sud',
  CAL: 'sud',
  CAM: 'sud',
  EMR: 'nord-est',
  FVG: 'nord-est',
  LAZ: 'centro',
  LIG: 'nord-ovest',
  LOM: 'nord-ovest',
  MAR: 'centro',
  MOL: 'centro',
  PIE: 'nord-ovest',
  PUG: 'sud',
  SAR: 'centro',
  SIC: 'sud',
  TOS: 'centro',
  TAA: 'nord-est',
  UMB: 'centro',
  VDA: 'nord-ovest',
  VEN: 'nord-est',
};

export function defaultRegionAssignments(): RegionAssignments {
  return { ...DEFAULT_REGION_ASSIGNMENTS };
}

export function storedRegionAssignments(value: unknown): RegionAssignments {
  const assignments = defaultRegionAssignments();
  if (!value || typeof value !== 'object') return assignments;

  for (const { code } of ITALIAN_REGIONS) {
    const storedArea = (value as Record<string, unknown>)[code];
    if (storedArea === null || (typeof storedArea === 'string' && territorialAreaIds.has(storedArea))) {
      assignments[code] = storedArea as TerritorialAreaId | null;
    }
  }

  return assignments;
}

export function regionsInArea(assignments: RegionAssignments, areaId: TerritorialAreaId) {
  return ITALIAN_REGIONS.filter(({ code }) => assignments[code] === areaId);
}

export function unassignedRegions(assignments: RegionAssignments) {
  return ITALIAN_REGIONS.filter(({ code }) => assignments[code] === null);
}
